import { Spinner } from "@/shared/components/ui";
import {
  selectHasPaid,
  selectIsAuthenticated,
  selectIsAuthenticating,
} from "@/store/slices/auth";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

/**
 * Wraps paid-only content: /courses.
 *
 * - session check pending → hold
 * - logged out            → /login
 * - not paid yet          → top of the payment funnel
 */
export const RequirePaid = () => {
  const isAuthenticating = useSelector(selectIsAuthenticating);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const hasPaid = useSelector(selectHasPaid);

  if (isAuthenticating) return <Spinner size="md" />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!hasPaid) return <Navigate to="/payment/methods" replace />;

  return <Outlet />;
};
